import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_ROLE_NAMES = ['Admin', 'Seller', 'Buyer'];

function useRoleDisplayName() {
  const { t } = useTranslation();

  const getRoleDisplayName = useCallback(
    (roleName: string) => {
      if (DEFAULT_ROLE_NAMES.includes(roleName)) {
        return t(
          `Settings:PageSettings.perspectives.roles.defaultRoles.${roleName}`,
        );
      }
      return roleName;
    },
    [t],
  );

  return { getRoleDisplayName };
}

export default useRoleDisplayName;
